import { useLang } from "@/i18n";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w, i) => (
      <span key={`${w}-${i}`} className="flex items-center">
        <span className="font-display italic font-light text-5xl md:text-7xl text-charcoal/25 px-8 md:px-14 whitespace-nowrap">
          {w}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-gold/60" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { t } = useLang();
  const words = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" aria-hidden="true"
      className="overflow-hidden border-y border-charcoal/10 bg-ivory py-10 md:py-14">
      <div className="marquee-track">
        <Row words={words} />
        <Row words={words} />
      </div>
    </div>
  );
};

export default Marquee;
